import { waLink, WHATSAPP_INTENTS } from "../config";

const priceBadges = ["Sabit Fiyat", "Günlük Hazırlanır", "Doyurucu", "Planlı Teslimat"];

const priceItems = [
  "Her gün sevdiğin menüyü seç",
  "Günlük hazırlanan sıcak yemek",
  "Belirlenen teslimat aralığı",
  "Başlangıç sipariş modeli sipariş öncesinde açıkça gösterilir",
];

export default function Pricing() {
  return (
    <section id="fiyat" className="bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
          {/* Left: red price card */}
          <div className="bg-primary-500 rounded-2xl p-8 md:p-10 text-background-50 dark:text-foreground-950 flex flex-col justify-center">
            <span className="text-xs font-bold tracking-[0.25em] uppercase opacity-80">
              Günlük Öğün
            </span>
            <div className="mt-4 flex items-baseline gap-2">
              <span className="font-heading text-6xl md:text-7xl font-bold">330</span>
              <span className="font-heading text-3xl font-bold">₺</span>
            </div>
            <div className="mt-5 flex flex-wrap gap-2">
              {priceBadges.map((b) => (
                <span
                  key={b}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/15 text-sm font-semibold whitespace-nowrap"
                >
                  <i className="ri-check-line"></i>
                  {b}
                </span>
              ))}
            </div>
            <ul className="mt-7 space-y-3">
              {priceItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <i className="ri-check-line text-lg mt-0.5"></i>
                  <span className="text-sm leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: plan info */}
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 flex flex-col justify-center">
            <span className="text-xs font-bold tracking-[0.25em] text-accent-700 uppercase">
              Ev Menüsü
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              İlk siparişini kolayca planla.
            </h2>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              Menünü seç, günlük hazırlayalım ve planlanan saatte teslim edelim.
            </p>

            <div className="mt-6 bg-background-50 border border-background-200 rounded-lg p-5">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-full bg-accent-100 text-accent-900 flex items-center justify-center shrink-0">
                  <i className="ri-information-line text-lg"></i>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  <strong className="text-foreground-900">
                    İlk sipariş modeli 2 öğünlük başlangıç planıyla çalışır.
                  </strong>{" "}
                  Sipariş şartlarının tüm detayları satın alma öncesinde açıkça
                  gösterilir.
                </p>
              </div>
            </div>

            <a
              href={waLink(WHATSAPP_INTENTS.firstOrder)}
              target="_blank"
              rel="nofollow noopener"
              className="mt-7 inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer self-start"
            >
              BÖLGEMİ KONTROL ET
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}